<div class="container">
    <div id="filters-container">
        <h2>Definir Regra de Tributação IBS/CBS</h2>
        <form [formGroup]="formGroup">
                <mat-form-field  class="full-input-grid" appearance="outline" floatLabel="always">
                <mat-label>Tributação IBS/CBS </mat-label>
                <mat-select formControlName="id">
                    <mat-option *ngFor="let option of taxationsCClasstrib" [value]="option.id">
                        {{option.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <br>
            <button style="margin-bottom: 20px;" type="button" *ngIf="enableSaveButton" mat-flat-button id="filterButton" (click)="saveClick()" >Definir</button>

        </form>
    </div>

<ng-container *ngIf="productsDataSource" s>
    <table mat-table class="demo-table" *ngIf="productsDataSource"
        [dataSource]=productsDataSource>


        <ng-container matColumnDef="column-code">
            <th class="column-code" mat-header-cell *matHeaderCellDef> {{ 'product.code' | translate | titlecase}}</th>
            <td class="column-code" mat-cell *matCellDef="let element"> {{element.code}}</td>
        </ng-container>
        
        <ng-container matColumnDef="column-name">
            <th class="name-column" mat-header-cell *matHeaderCellDef> {{ 'product.name' | translate }}</th>
            <td class="name-column" mat-cell *matCellDef="let element"> {{element.name}}</td>
        </ng-container>






        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
            <div class="paginator-container">
        <div *ngIf="_data && _data.length>0" class="selected-counter">
            <span>Produtos selecionados: {{ _data.length }}</span>
        </div>
        </div>
    </ng-container>
  

    <div *ngIf="!_data || _data.length==0 " class="no-product-div">
        <span class="no-product">{{ 'product.noProduct' | translate }}</span>
    </div>

</div>